import { IApolloCacheParams } from '../../../lib/cache.types';
import { IArchivableProps } from '../../../lib/query.types';
import { mergeCacheLists } from '../../../lib/utils';
import { GET_ENTITIES } from './entity.queries';
import { IEntitiesResults } from './entity.types';

export const updateEntityCache = ({
  cache,
  entities,
  remove
}: IApolloCacheParams & IEntitiesResults & { remove?: boolean }) => {
  const currEntities =
    cache.readQuery<IEntitiesResults, IArchivableProps>({
      query: GET_ENTITIES,
      variables: { includeArchived: true }
    })?.entities ?? [];

  if (currEntities)
    cache.writeQuery<IEntitiesResults, IArchivableProps>({
      query: GET_ENTITIES,
      data: {
        entities: remove
          ? currEntities.filter((curr) => !entities.find((e) => e._id === curr._id))
          : mergeCacheLists(currEntities, entities)
      },
      variables: { includeArchived: true },
      overwrite: true
    });
};
